import swal from "sweetalert2";

export const customInputWarning = async(logger) => { 
	try {
		const result = await swal.fire({
			title: "Warning!",
			html:
			`You are attempting to enable Custom Input mode for a selection field.
				<br/>
				<br/>
				Please note that any text entered in this field will <i>not</i> associate to any items in the list, even if the text matches exactly.
				This mode is <i>only</i> intended for situations in which the correct value is not present in the list.
				<br/>
				<br/>
				Are you sure you want to do that?`,
			showCloseButton: true,
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#8CC541",
			confirmButtonText: "Yes, do it!",
			focusCancel: true,
			reverseButtons: true
		});

		return result;
	}
	catch(err) {
		logger.error(err);

		return { dismiss: swal.DismissReason.cancel };
	}
};